export default __webpack_public_path__ + "static/media/loading2.c70bb52c.gif";